'use client'
import {createContext, useState, useEffect} from 'react'
import { useRouter, usePathname } from 'next/navigation'

const WebContext = createContext()

export default function WebProvider({children}) {
    const pathname = usePathname();
    const isHome = pathname === "/";
    const [pageIsLoaded, setPageIsLoaded] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false)
    const router = useRouter();
    const [backgroundHeader, setBackgroundHeader] = useState(true)
    const [colorHeader, setColorHeader] = useState('black')
    const [openOverview, setOpenOverview] = useState(false)
    const [pastColorHeader, setPastColorHeader] = useState('black')
    const [pastBackgroundHeader, setPastBackgroundHeader] = useState(true)
    
    

    async function changePageIsLoaded() {
        setPageIsLoaded(true)  
    }

    return (
        <WebContext.Provider
            value={{
                changePageIsLoaded,
                pageIsLoaded,
                menuOpen,
                setMenuOpen,
                colorHeader, 
                setColorHeader,
                backgroundHeader, 
                setBackgroundHeader,
                openOverview, 
                setOpenOverview,
                pastColorHeader, 
                setPastColorHeader,
                pastBackgroundHeader,
                setPastBackgroundHeader,
                isHome
            }}
        >
            {children}
        </WebContext.Provider>
    )
}

const WebConsumer = WebContext.Consumer

export {WebConsumer, WebContext}
